import DescriptionPage from '@/pages/DescriptionPage/index';

import FamilyDescription from '@/pages/DescriptionPage/FamilyDescription';
import PreviewForDonor from '@/pages/DescriptionPage/PreviewForDonor';

export default {
    path: '/opis/:familyId',
    props: true,
    component: DescriptionPage,
    meta: { requiresAuth: true },
    children: [
        {
            path: '',
            component: FamilyDescription,
            name: 'family-description',
            meta: { requiresAuth: true }
        },
        {
            path: '/podglad-dla-darczyncy/:familyId',
            component: PreviewForDonor,
            name: 'preview-for-donor',
            meta: { requiresAuth: true }
        }
    ]
};
